import { useState } from 'react';

import { arrayOf, func, objectOf, shape, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Button, Flex, Label, Text } from '@olist/united';

import { IDontKnowMyCEP } from '../../../constants/externals-urls';
import Api from '../../../service';
import FormInput from '../form-input/form-input';

const PostalCodeSearchInput = ({ label, onSearchError, onSearchSuccess, ...props }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const { id, input, meta } = props;

  const handleButtonClick = async () => {
    if (isLoading) return;
    if (!meta.valid) return;

    setIsLoading(true);

    try {
      const postalCode = input.value.replace('-', '');
      const address = await Api.getViaCEPAddressByCep(postalCode);

      if (Object.keys(address?.addressInfo).length === 0) throw Error(t`postal code doesn't exist`);

      onSearchSuccess?.({ ...address }, address?.hasHubCoverage);
    } catch (exception) {
      onSearchError(exception);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Label htmlFor={id}>{label}</Label>
      <Flex flexWrap="wrap" m={-2}>
        <Box width="320px" m={2}>
          <FormInput {...props} disabled={isLoading} />
          <Box my={2}>
            <Text.Link
              href={IDontKnowMyCEP}
              target="_blank"
            >{t`I don't know my postal code`}</Text.Link>
          </Box>
        </Box>
        <Box m={2}>
          <Button
            onClick={handleButtonClick}
            loading={isLoading}
            disabled={!meta.valid || !meta.visited}
            type="button"
          >{t`query postal code`}</Button>
        </Box>
      </Flex>
    </>
  );
};

PostalCodeSearchInput.defaultProps = {
  initialErrors: {},
};

PostalCodeSearchInput.propTypes = {
  label: string.isRequired,
  id: string.isRequired,
  initialErrors: objectOf(arrayOf(shape({}))),
  meta: shape({}).isRequired,
  input: shape({}).isRequired,
  onSearchSuccess: func.isRequired,
  onSearchError: func.isRequired,
};

export default PostalCodeSearchInput;
